<template>
  <div class="page-box">
    <!-- 头部组件 -->
    <ProductHeader :currentTab="1" stepTitle="房型/价格计划"></ProductHeader>
    <div class="page-main">
      <!-- 发布助手 -->
      <PublishHelper></PublishHelper>
      <div class="main-content">
        <a-card :bordered="false" :headStyle="{borderBottom:'0px'}" :bodyStyle="{paddingTop:'0px'}">
          <a-row slot="title">
            <a-col :span="8">
              <span class="card-title">预订设置</span>
            </a-col>
          </a-row>
          <a-form-item label="住客信息" v-bind="baseItemLayout">
            <a-checkbox :default-checked="true" :disabled="true">
              真实姓名
            </a-checkbox>
            <a-checkbox v-model="cardId">
              身份证号
            </a-checkbox>
          </a-form-item>
          <a-form-item v-bind="baseItemLayout" label="  " :colon="false" :required="false">
            <a-button :disabled="proSource!=0" type="primary" @click="onSubmit" :loading="submitLoading">提交并下一步
            </a-button>
          </a-form-item>

        </a-card>
      </div>
    </div>
  </div>
</template>

<script>
import ProductHeader from '../components/ProductHeader'
import PublishHelper from '../components/PublishHelper'
import formMixin from '@/utils/mixins/formMixins'

export default {
  name: 'HotelBookSet',
  mixins: [formMixin],
  components: {
    ProductHeader,
    PublishHelper
  },
  data() {
    return {
      proSource: this.$route.query.proSource, //判断自有产品还是非自有产品
      proId: this.$route.query.proId, //产品ID
      catalogId: this.$route.query.catalogId,
      cardId: false,
      submitLoading: false
    }
  },
  mounted() {
    this.getBookInfo()
  },
  methods: {
    getBookInfo() {
      this.getHttpServices().getProService().post('product/hotel/getBookInfo?proId=' + this.proId, {}).then(res => {
        let arr = res.hotelLodgerCondition.split(',')
        if (arr.length > 1) {
          this.cardId = true
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSubmit() {
      let hotelLodgerCondition = this.cardId ? '1,2' : '1'
      let parameter = {
        hotelLodgerCondition: hotelLodgerCondition,
        proId: this.proId
      }
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getProService().post('product/hotel/editBookInfo', parameter).then(res => {
          this.getLogUtils().logWithTag('submitData', res)
          this.$message.success('预订设置保存成功')
          this.$router.push({
            name: 'HotelOptionList',
            query: {
              proId: this.proId,
              catalogId: this.catalogId,
              proSource: this.proSource
            }
          })
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }

  }

}
</script>
<style lang="less" scoped>
.page-box {
  .page-main {
    margin: 10px;
    display: flex;

    .main-content {
      margin-left: 10px;
      width: 400px;
      flex-grow: 1;
    }
  }
}

.pt10 {
  padding-top: 10px;
}

.card-title {
  padding-left: 10px;
  border-left: 1px solid #FAAD14;
  line-height: 32px;
  margin-right: 5px;
}

.card-txt {
  font-size: 12px;
}

.mr5 {
  margin-right: 5px;
}
</style>